import { useTranslation } from "react-i18next";
import { countryFlagUrl, translateCountry } from "@/lib/format";

export function CountryLabel({
  code,
  name,
  className = "",
  showName = true,
  size = 20,
}: {
  code: string | null | undefined;
  name?: string | null;
  className?: string;
  showName?: boolean;
  size?: 20 | 40 | 80;
}) {
  const { i18n } = useTranslation();
  const label = translateCountry(code, name, i18n.language);
  const url = countryFlagUrl(code, size);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      {url ? (
        <img
          src={url}
          alt=""
          aria-hidden
          width={size}
          height={Math.round((size * 3) / 4)}
          className="inline-block rounded-[2px] ring-1 ring-ink/10 flex-shrink-0"
        />
      ) : null}
      {showName && <span className="truncate">{label}</span>}
    </span>
  );
}
